export const TEST_ID = 'johnDeereExportModal';

export const EXPORT_STEP_SUMMARY = 1;

export const EXPORT_STEP_MAP_LAYER = 2;

export const EXPORT_STEP_FILE_RESOURCE = 3;

export const EXPORT_STEP_UPLOAD = 4;

export const EXPORT_TITLE_PREFIX = 'Exedy Spray Map';
